<template>
  <div class="user nav-mobile-menu">
    <div class="photo">
      <span class="sidebar-normal"><i class="ti-plus"></i></span>
    </div>
    <div class="info">
      <a data-toggle="collapse" :aria-expanded="!isClosed" @click="toggleMenu" href="#">
         <span>
           Add A New
           <b class="caret"></b>
        </span>
      </a>
      <div class="clearfix"></div>
      <div>
        <collapse-transition>
          <ul class="nav nav-menu" v-show="!isClosed">
            <li>
              <a href="#/settings/accounts/add">
                <span class="sidebar-mini-icon"><i class="ti-wallet"></i></span>
                <span class="sidebar-normal">Account</span>
              </a>
            </li>
            <!--<li>
              <a href="#/transactions/add">
                <span class="sidebar-mini-icon"><i class="ti-exchange-vertical"></i></span>
                <span class="sidebar-normal">Transaction</span>
              </a>
            </li> -->
            <li>
              <a href="#/budget/add">
                <span class="sidebar-mini-icon"><i class="ti-pie-chart"></i></span>
                <span class="sidebar-normal">Budget</span>
              </a>
            </li>
            <li>
              <a href="#/goals/add">
                <span class="sidebar-mini-icon"><i class="ti-target"></i></span>
                <span class="sidebar-normal">Goal</span>
              </a>
            </li>
          </ul>
        </collapse-transition>
      </div>
    </div>
  </div>
</template>
<script>
  import { CollapseTransition } from 'vue2-transitions'

  export default {
    components: {
      CollapseTransition
    },
    data() {
      return {
        isClosed: false
      }
    },
    methods: {
      toggleMenu() {
        this.isClosed = !this.isClosed
      }
    }
  }
</script>
<style scoped>
  .nav.nav-menu {
    margin-top: 0;
  }
</style>
